import { userService } from "../api/user-auth";

const state = {
  sites: [],
  new_site: null,
};

const getters = {
  // eslint-disable-next-line no-unused-vars
  sites: (state, getters) => {
    return state.sites;
  },
};

const actions = {
  loadSites({ commit }, sites) {
    commit("loadSites", sites);
  },
  getSites({ dispatch, commit }) {
    userService.getJson("site/list").then(
      response => {
        if (response.ok) {
          commit("loadSites", response.data);
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiSaveSite({ dispatch, commit }, site) {
    userService.post("site/" + site.id, site).then(
      response => {
        if (response.ok) {
          commit("updateSite", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiCreateSite({ dispatch, commit }, site) {
    userService.post("site/" + site.id, site).then(
      response => {
        if (response.ok) {
          commit("addSite", response.data);
          dispatch("customers/addSite", response.data, { root: true });
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  addSite({ commit }, site) {
    commit("addSite", site);
  },
  addPlant({ commit }, plant) {
    commit("addPlant", plant);
  },
};

const mutations = {
  addSite(state, site) {
    state.sites.push(site);
    state.new_site = site;
  },
  addPlant(state, plant) {
    var index = state.sites.findIndex(v => v.id == plant.site_id);
    if (state.sites[index] !== undefined) {
      state.sites[index].plants.push(plant);
    }
  },
  updateSite(state, site) {
    var index = state.sites.findIndex(v => v.id == site.id);
    state.sites[index] = site;
  },
  loadSites(state, sites) {
    state.sites = sites;
  },
  clear(state) {
    state.sites = [];
  },
};

export const sites = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
